import { useCallback as e } from "react";
import { useTranslation as t } from "@maat/store-i18n";
import { addDaysToDateString as n } from "@maat/datetime";
//#region src/components/DatePicker/hooks/useDisabledDateReason.ts
function r({ picking: r, start: i, minNights: a, maxNights: o, blockedRanges: s, disabledStartDates: c, disabledEndDates: l, effectiveMax: u, reasons: d }) {
	let { t: f } = t("ds");
	return e((e) => {
		let t = s?.some((t) => e >= t.from && e <= t.to) ?? !1;
		if (r === "start") return c?.includes(e) ? d?.disabledStart ?? f("ds:datePicker.reason.unavailableCheckIn") : t ? d?.blocked ?? f("ds:datePicker.reason.unavailable") : void 0;
		if (!(!i || e <= i)) {
			if (a && e < n(i, a)) return f("ds:datePicker.reason.minNights", { count: a });
			if (o && e > n(i, o)) return f("ds:datePicker.reason.maxNights", { count: o });
			if (l?.includes(e)) return d?.disabledEnd ?? f("ds:datePicker.reason.checkoutUnavailable");
			if (t) return d?.blocked ?? f("ds:datePicker.reason.unavailable");
			if (u && e > u) return d?.blocked ?? f("ds:datePicker.reason.spanUnavailable");
		}
	}, [
		f,
		r,
		i,
		a,
		o,
		s,
		c,
		l,
		u,
		d?.disabledStart,
		d?.disabledEnd,
		d?.blocked
	]);
}
//#endregion
export { r as useDisabledDateReason };
